/**
 * Returns a promise, which will resolve in `timeout` ms
 */
export function delay(timeout = 0) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(undefined);
    }, timeout);
  });
}
